export const DRIVER_JSON_MAP = {
  firstName: 'First Name',
  lastName: 'Last Name',
  policyNumber: 'Policy Number',
  phoneNumber: 'Phone Number',
  streetAddress: 'Street Address',
  zipCode: 'Zip Code',
  emailAddress: 'Email Address',
  removeHousehold: {
    firstName: 'Remove Household Member First Name',
    lastName: 'Remove Household Member Last Name',
    isMovingToNewAddress: 'Is the household member moving to a new address?',
    vehicleAccess:
      'Will the household member have access to, or take a vehicle that is currently insured on the policy',
    newAddress: {
      streetAddress: 'Household member new Street Address',
      apt: 'Household member new Apartment#',
      city: 'Household member new City',
      state: 'Household member new State',
      zipCode: 'Household member new Zip Code'
    }
  },
  effectDate: 'What date would you like this change to go into effect?'
}
